import { createI18n } from "vue-i18n";

const loadLocaleMessages = function() {
  const locales = require.context("./", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages: any = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
};

const i18n = createI18n({
  locale: navigator.language, // set locale
  fallbackLocale: "en", // set fallback locale
  messages: loadLocaleMessages() // set locale messages
});

export default i18n;
